import React, { useState } from 'react';
import { Home, Hammer, Droplets, ShieldAlert, Building2, ArrowRight } from 'lucide-react';
type TradeTab = {
  id: string;
  label: string;
  icon: React.ReactNode;
  environment: string;
  pain: string;
  benefit: string;
};
const trades: TradeTab[] = [{
  id: 'roofers',
  label: 'Roofers & Attic Crews',
  icon: <Home className="w-5 h-5" data-id="element-633" />,
  environment: 'Hot attics, tight access, ladders',
  pain: 'Hauling 40lb backpack sprayers up ladders into 130°F attics',
  benefit: '75 feet of hose means the sprayer stays on the ground. You just carry the wand.'
}, {
  id: 'crawlspace',
  label: 'Crawlspace & Encapsulation',
  icon: <Hammer className="w-5 h-5" data-id="element-634" />,
  environment: 'Low clearance, moisture, limited mobility',
  pain: 'Dragging heavy equipment through 2-foot crawlspaces',
  benefit: 'Siphon from a bucket outside. The hose goes where you go.'
}, {
  id: 'basement',
  label: 'Basement Waterproofing',
  icon: <Droplets className="w-5 h-5" data-id="element-635" />,
  environment: 'Damp basements, concrete surfaces, large areas',
  pain: 'Constant refilling of small pump sprayers on big jobs',
  benefit: 'Continuous spray from any container. No refills, no interruptions.'
}, {
  id: 'restoration',
  label: 'Restoration & Remediation',
  icon: <ShieldAlert className="w-5 h-5" data-id="element-636" />,
  environment: 'Mold, fire damage, biohazard cleanup',
  pain: 'Chemical exposure from pouring and splashing during transfers',
  benefit: 'Closed siphon system keeps chemicals contained. Spray safely.'
}, {
  id: 'facilities',
  label: 'Facilities & Property Maintenance',
  icon: <Building2 className="w-5 h-5" data-id="element-637" />,
  environment: 'Schools, hospitals, commercial buildings',
  pain: 'Battery sprayers dying mid-shift across large facilities',
  benefit: 'Corded electric power. Plug in and spray all day. No batteries.'
}];
export function WhoItsForSection() {
  const [activeTab, setActiveTab] = useState(0);
  return <section className="py-20 bg-white" data-id="element-638">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-639">
        <div className="text-center mb-12" data-id="element-640">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-641">
            Built For Your Trade
          </h2>
          <p className="text-xl text-gray-600" data-id="element-642">
            See how ForceX solves problems in your specific environment.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 max-w-6xl mx-auto" data-id="element-643">
          {/* Tabs List */}
          <div className="lg:col-span-4 flex flex-col space-y-2" data-id="element-644">
            {trades.map((trade, index) => <button key={trade.id} onClick={() => setActiveTab(index)} className={`flex items-center p-4 rounded-lg text-left transition-all duration-200 border-l-4 ${activeTab === index ? 'bg-brand-light border-brand-yellow shadow-sm' : 'bg-white border-transparent hover:bg-gray-50 text-gray-600'}`} data-id="element-645">
                <div className={`mr-4 p-2 rounded-full ${activeTab === index ? 'bg-brand-yellow text-brand-dark' : 'bg-gray-100 text-gray-500'}`} data-id="element-646">
                  {trade.icon}
                </div>
                <span className={`font-bold ${activeTab === index ? 'text-brand-dark' : 'text-gray-600'}`} data-id="element-647">
                  {trade.label}
                </span>
              </button>)}
          </div>

          {/* Tab Content */}
          <div className="lg:col-span-8" data-id="element-648">
            <div className="bg-brand-dark text-white rounded-2xl p-8 md:p-12 h-full flex flex-col justify-center relative overflow-hidden" data-id="element-649">
              {/* Background accent */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-brand-yellow opacity-5 rounded-full -mr-20 -mt-20 blur-3xl" data-id="element-650"></div>

              <div className="relative z-10" data-id="element-651">
                <div className="flex items-center mb-8" data-id="element-652">
                  <div className="p-3 bg-brand-yellow rounded-lg mr-4 text-brand-dark" data-id="element-653">
                    {trades[activeTab].icon}
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold" data-id="element-654">
                    {trades[activeTab].label}
                  </h3>
                </div>

                <div className="space-y-8" data-id="element-655">
                  <div data-id="element-656">
                    <h4 className="text-brand-yellow font-bold text-sm uppercase tracking-wider mb-2" data-id="element-657">
                      The Environment
                    </h4>
                    <p className="text-xl text-gray-300" data-id="element-658">
                      {trades[activeTab].environment}
                    </p>
                  </div>

                  <div data-id="element-659">
                    <h4 className="text-red-400 font-bold text-sm uppercase tracking-wider mb-2" data-id="element-660">
                      The Pain
                    </h4>
                    <p className="text-xl text-gray-300" data-id="element-661">
                      "{trades[activeTab].pain}"
                    </p>
                  </div>

                  <div className="bg-white/10 p-6 rounded-xl border border-white/10" data-id="element-662">
                    <h4 className="text-brand-yellow font-bold text-sm uppercase tracking-wider mb-2 flex items-center" data-id="element-663">
                      The ForceX Advantage{' '}
                      <ArrowRight className="w-4 h-4 ml-2" data-id="element-664" />
                    </h4>
                    <p className="text-2xl font-bold text-white" data-id="element-665">
                      {trades[activeTab].benefit}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}